import { inheritsLoose as _inheritsLoose, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { createRef, Component } from 'react';

// HOC that provides mouseX and mouseY relative to parent
var MousePositionHOC = function MousePositionHOC() {
  return function (InnerComponent) {
    return /*#__PURE__*/function (_Component) {
      _inheritsLoose(MousePosition, _Component);
      function MousePosition() {
        var _this;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
        _this.state = {
          x: 0,
          y: 0
        };
        _this.container = /*#__PURE__*/createRef();
        _this.onMouseMove = function (_ref) {
          var _this$container;
          var clientX = _ref.clientX,
            clientY = _ref.clientY;
          var bbox = (_this$container = _this.container) === null || _this$container === void 0 ? void 0 : _this$container.current.getBoundingClientRect();
          _this.setState({
            x: clientX - bbox.left,
            y: clientY - bbox.top
          });
        };
        return _this;
      }
      var _proto = MousePosition.prototype;
      _proto.render = function render() {
        var _this$state = this.state,
          x = _this$state.x,
          y = _this$state.y;
        return /*#__PURE__*/React.createElement("div", {
          ref: this.container,
          onMouseMove: this.onMouseMove
        }, /*#__PURE__*/React.createElement(InnerComponent, _extends({}, this.props, {
          mouseX: x,
          mouseY: y
        })));
      };
      return MousePosition;
    }(Component);
  };
};
var MousePosition = MousePositionHOC;

export { MousePosition as default };
